import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-light.svg'


const _withScopeId = n => (_pushScopeId("data-v-cae7ca86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid vertical-container p-flex-nowrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-6 p-grid vertical-container side p-ai-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "logo p-mx-auto",
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "p-col-6" }
const _hoisted_4 = { class: "c-slot-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_toast = _resolveComponent("base-toast")!
  const _component_base_confirm_modal = _resolveComponent("base-confirm-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ]),
    _createVNode(_component_base_toast),
    _createVNode(_component_base_confirm_modal)
  ], 64))
}